export default{
  methods: {
    // 时间转时间戳
    getDateTimeStamp (dateStr) {
      return Date.parse(dateStr.replace(/-/gi, '/'))
    },
     // 时间戳转换成日期时间
    formatTimeReturn (number, format) {
      var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
      var returnArr = []
      var date = new Date(number * 1000)
      returnArr.push(date.getFullYear())
      returnArr.push(this.formatNumber(date.getMonth() + 1))
      returnArr.push(this.formatNumber(date.getDate()))

      returnArr.push(this.formatNumber(date.getHours()))
      returnArr.push(this.formatNumber(date.getMinutes()))
      returnArr.push(this.formatNumber(date.getSeconds()))
      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i])
      }
      return format
    },
    formatNumber (n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    // 计算时间差
    timeDifference (time) {
      let date = time / 1000
      let day = Math.floor(date / 86400)
      let hour = Math.floor(date % 86400 / 3600)
      let minute = Math.floor(date % 86400 % 3600 / 60)
      let s = Math.floor(date % 86400 % 3600 % 60 % 60)
      return {
        day: day + ':' + hour + ':' + minute + ':' + s,
        Day: day + '天' + hour + ':' + minute + ':' + s,
        Days: hour + ':' + minute + ':' + s
      }
    },
    timestampToTimes (timestamp) {
      var date = new Date(timestamp)
      // var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
      var D = date.getDate() + '日'
      var h = date.getHours()
      var m = date.getMinutes()
      // var s = date.getSeconds()
      return M + D + ' ' + h + ':' + m
    },
    timeToDateStr (time) {
      var differTime = parseInt((new Date().getTime() - time) / 1000)
      if (differTime <= 0) {
        return '刚刚'
      } else if (differTime < 60) {
        return differTime + '秒前'
      } else if (differTime < 3600) {
        return parseInt(differTime / 60) + '分钟前'
      } else if (differTime < 86400) {
        return parseInt(differTime / 3600) + '小时前'
      } else if (differTime < 2592000) {
        return parseInt(differTime / 86400) + '天前'
      } else if (differTime < 31104000) {
        return parseInt(differTime / 2592000) + '月前'
      } else {
        return parseInt(differTime / 31104000) + '年前'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/util.js